export default __webpack_public_path__ + "static/media/dr-priya-d.f28b6a74.jpg";